<!-- logo-parrain.component.html -->
@if (isLoading()) {
<!-- État de chargement -->
<div [class]="containerTailwindClasses()">
  <div class="animate-pulse bg-gray-200 rounded-md w-full h-full"></div>
</div>
} @else if (hasError()) {
<!-- État d'erreur -->
<div [class]="containerTailwindClasses()">
  <div class="text-red-500 text-xs text-center">Erreur</div>
</div>
} @else if (shouldShowSwiper()) {
<!-- Affichage en swiper pour plusieurs sponsors principaux -->
<div class="relative "> <!-- wrapper ajouté -->
 <!-- Affichage en swiper pour plusieurs sponsors principaux -->
<div class="flex flex-col items-center  "> <!-- wrapper colonne -->
  <div [class]="containerTailwindClasses()" [attr.data-swiper-key]="swiperKey()">
       <swiper
      [config]="swiperConfig"
      class="w-full h-full flex items-center justify-center"
      (swiper)="onSwiper($event)"
    >
      @for (sponsor of mainSponsors(); track sponsor.id) {
        <ng-template swiperSlide>
          <div class="w-full h-full flex items-center justify-center relative" [class]="buildContainerClass(sponsor)">
            <img
              [class]="buildLogoClass(sponsor)"
              [ngSrc]="buildLogoUrl(sponsor)"
              [width]="imageWidth()" [height]="imageHeight()"
              [alt]="sponsor.name"
              (click)="parrainClicked.emit(sponsor.id)"
              loading="lazy"
            />
          </div>
        </ng-template>
      }
    </swiper>
  </div>

  <!--  timer en dehors, plus de clipping -->
<div *ngIf="showTimer"
         class="absolute bottom-1 right-1 text-[10px] leading-none px-1.5 py-0.5 rounded
                bg-black/60 text-white backdrop-blur-sm pointer-events-none z-10">
      {{ remainingLabel() }}
    </div>

</div>

</div>
} @else {
<!-- Affichage simple pour un seul sponsor -->
@if (logoSrc(); as src) {
<div class="flex items-center justify-center" [class]="containerClass()">
  <img [class]="logoClass()" [ngSrc]="src" [width]="imageWidth()" [height]="imageHeight()" alt="{{parrain()?.name}}"
    loading="lazy" (click)="parrainClicked.emit(parrain()?.id)" class="cursor-pointer" />
</div>
} @else {
<!-- Logo par défaut -->
<div [class]="containerTailwindClasses()">
  <img class="w-14 h-auto object-contain" ngSrc="assets/images/logo/kappsi-logo.png" [width]="imageWidth()"
    [height]="imageHeight()" alt="Logo par défaut" loading="lazy" />
</div>
}
}


<!-- <app-logo-parrain
  context="sidebar"  ///pour dire ou en laffiche 
  [useMainSponsor]="true" //// pour utiliser le sponsor principal
   [fillImage]="true" ////pour remplir l'image dans le conteneur
  [showTimer]="true" /////pour affichier le timer
  customClass="cursor-pointer" // pour ajouter une classe personnalisée
  (parrainClicked)="onShowParrainSpace($event)" /////pour gérer le clic sur le logo
></app-logo-parrain> -->